import { jsx as _jsx } from "react/jsx-runtime";
export const headTagThemeBuilder = head => {
  var _a, _b;

  if (!head) {
    return [];
  }

  return ((_a = head.link) !== null && _a !== void 0 ? _a : []).map((p, i) => {
    var _a;

    return _jsx("link", Object.assign({}, p), (_a = p.href) !== null && _a !== void 0 ? _a : i);
  }).concat(((_b = head.meta) !== null && _b !== void 0 ? _b : []).map((p, i) => {
    var _a;

    return _jsx("meta", Object.assign({}, p), (_a = p.name) !== null && _a !== void 0 ? _a : i);
  }));
};
//# sourceMappingURL=headTagTheme.js.map